import Logo from "../../assets/images/BX-LOGO.svg";
import {Link, useParams} from "react-router-dom";
import {useState} from "react";
import {useMutation} from "@tanstack/react-query";
import {resetPassword} from "../../api/api";
import {toast} from "react-toastify";
import {Button, Form, FormFeedback, FormGroup, Input, Label} from "reactstrap";
import {useNavigate} from 'react-router-dom';


function PasswordResetConfirmPage(props) {

    const {uidb64, token} = useParams();
    const [password1, setPassword1] = useState("");
    const [password2, setPassword2] = useState("");
    const navigate = useNavigate()

    const resetPasswordMutation = useMutation({
        mutationFn: resetPassword,
        onSuccess: (data, variables) =>{
            setPassword1('')
            setPassword2('')

            toast.success('Password has been reset successfully!', {
                autoClose: false,
                closeOnClick: true,
                progress: undefined,
            })
            navigate("/login")
        },
        onError: (err) => {
            toast.error(err.response.data.error)
        }
    })
    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("uidb64", uidb64);
        formData.append("token", token);
        formData.append("password1", password1);
        formData.append("password2", password2);
        resetPasswordMutation.mutate(formData)
    };

    return (
        <>
            <div className="account-pages mt-5 mb-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div className="card">
                                <div className="card-body p-4">
                                    <div className="text-center w-75 m-auto">
                                        <span>
                                            <img
                                                src={Logo}
                                                width="73"
                                                height="56"
                                                alt={Logo}/>
                                        </span>
                                        <p className="text-muted mb-4 mt-3">
                                            Set a new password.
                                        </p>
                                    </div>

                                    <Form onSubmit={handleSubmit}>
                                        <FormGroup className="form-group mb-3">
                                            <Label for="password1">
                                                New Password
                                                <span className="text-danger">*</span>
                                            </Label>
                                            <Input
                                                className="form-control"
                                                type="password"
                                                id="password"
                                                value={password1}
                                                placeholder="Enter your password"
                                                invalid={
                                                    resetPasswordMutation.isError &&
                                                    resetPasswordMutation.error.response.data.password1
                                                }
                                                onChange={(e) =>
                                                    setPassword1(e.target.value)
                                                }
                                            />
                                            <FormFeedback invalid>
                                                {
                                                    resetPasswordMutation.isError &&
                                                    resetPasswordMutation.error.response.data.password1}
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup className="form-group mb-3">
                                            <Label for="password2">
                                                Confirm New Password
                                                <span className="text-danger">*</span>
                                            </Label>
                                            <Input
                                                className="form-control"
                                                type="password"
                                                id="password2"
                                                value={password2}
                                                placeholder="Enter your password again"
                                                invalid={
                                                    resetPasswordMutation.isError &&
                                                    resetPasswordMutation.error.response.data.password2
                                                }
                                                onChange={(e) =>
                                                    setPassword2(e.target.value)
                                                }
                                            />
                                            <FormFeedback invalid>
                                                {
                                                    resetPasswordMutation.isError &&
                                                    resetPasswordMutation.error.response.data.password2}
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Button type="submit"
                                                    className="btn bx-btn-primary btn-block waves-effect waves-light mt-2"
                                            >
                                                Set Password
                                            </Button>
                                        </FormGroup>
                                    </Form>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12 text-center">
                                    <p className="text-muted">
                                        Go back to login?
                                        <Link
                                            to="/login"
                                            className="text-primary font-weight-medium ml-1"
                                        >
                                            Log In
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PasswordResetConfirmPage;